const mediaItems = [
  {
    title: '独家揭秘：某品牌代言人翻车事件全记录',
    duration: '12:38',
    views: '256万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20video%20frame%20with%20red%20play%20button%20overlay%2C%20abstract%20brand%20logo%20shattering%20effect%2C%20dramatic%20lighting%2C%20cinematic%20color%20grading%20with%20deep%20reds%20and%20shadows%2C%20breaking%20news%20aesthetic%2C%20investigative%20journalism%20style&width=800&height=500&seq=media-01-brand&orientation=landscape',
    tag: '深度解析',
  },
  {
    title: '暗网吃瓜群内部聊天记录流出，信息量炸裂',
    duration: '08:15',
    views: '189万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20phone%20screen%20with%20glowing%20red%20chat%20messages%2C%20encrypted%20communication%20aesthetic%2C%20mysterious%20digital%20interface%2C%20cyberpunk%20smartphone%20display%2C%20dramatic%20lighting%20from%20screen%2C%20dark%20room%20atmosphere&width=800&height=500&seq=media-02-chat&orientation=landscape',
    tag: '独家',
  },
  {
    title: '从蛛丝马迹到实锤：某案件完整时间线梳理',
    duration: '15:42',
    views: '143万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20investigation%20board%20with%20red%20strings%20connecting%20photos%20and%20documents%2C%20detective%20style%20evidence%20wall%2C%20dramatic%20single%20light%20source%2C%20crime%20investigation%20aesthetic%2C%20mysterious%20and%20tense%20mood%2C%20film%20noir%20photography&width=800&height=500&seq=media-03-timeline&orientation=landscape',
    tag: '深度解析',
  },
  {
    title: '圈内人亲述：那些年我们不敢说的娱乐圈秘密',
    duration: '20:06',
    views: '328万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20studio%20interview%20setting%20with%20silhouetted%20figure%20against%20red%20backlight%2C%20anonymous%20whistleblower%20aesthetic%2C%20dramatic%20rim%20lighting%2C%20mysterious%20atmosphere%2C%20professional%20video%20production%20quality%2C%20deep%20shadows&width=800&height=500&seq=media-04-secret&orientation=landscape',
    tag: '独家',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            吃瓜现场
          </h2>
          <span className="text-xs text-foreground-500 mt-1">视频爆料 · 深度解析</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden cursor-pointer group hover:bg-background-200/70 transition-colors"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-300 group-hover:text-primary-400 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-600">
                  {item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}